module.exports = __webpack_public_path__ + "img/award-mfa.d29db95d.png";